import React, { Fragment, useReducer } from "react";
import Paper from "@mui/material/Paper";

// Import both internal and external message components
import MessageList from "./message-list";
import MessageForm from "./message-form";
import AppMessageList from "./appMessage-list";
import AppMessageForm from "./appMessage-form";

const reducer = (state, action) => {
  switch (action.type) {
    case "fieldChanged":
      return { ...state, [action.field]: action.value };
    default:
      return state;
  }
};

const MessageContainer = ({
  className = '',
  id,
  recordId,
  recordType,
  setUnsavedChanges
}) => {
  const initialState = {
    latestMessage: null,
    latestAppMessage: null,
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Fragment>
      <Paper id={`internal-${id}`} className={`messages-container mt-30 ${className}`}>
        <h4 className="lead-notes-heading">INTERNAL MESSAGES</h4>

        <Fragment>
          <MessageList
            threadId={recordId}
            latestMessage={state.latestMessage}
            parentDispatch={dispatch}
            recordType={recordType}
            setUnsavedChanges
          />
          <MessageForm
            recordId={recordId}
            recordType={recordType}
            parentDispatch={dispatch}
            setUnsavedChanges={setUnsavedChanges}
          />
        </Fragment>
      </Paper>

      <Paper id={`app-${id}`} className={`messages-container mt-30 ${className}`}>
        <h4 className="app-messages-heading">CLIENT APP MESSAGES</h4>

        <Fragment>
          <AppMessageList
            threadId={recordId}
            latestAppMessage={state.latestAppMessage}
            parentDispatch={dispatch}
            recordType={recordType}
          />
          <AppMessageForm
            recordId={recordId}
            recordType={recordType}
            parentDispatch={dispatch}
            setUnsavedChanges={setUnsavedChanges}
          />
        </Fragment>
      </Paper>
    </Fragment>
  );
};

export default MessageContainer;
